import { useEffect, useState } from "react";
import styles from "./matchmaking-loading.module.css";
import { useTranslation } from "react-i18next";
import {
  days as daysConstants,
  centers as centersConstants,
} from "constants/preferences.constants";
import Spinner from "components/functional/spinner";

const MatchmakingLoading = ({
  preferences = [],
  onClick,
  canUpdatePreferences,
} = {}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [sportPlaces, setSportPlaces] = useState([]);

  const retrieveData = () => {
    // Get unique days
    const uniqueDays = [
      ...new Set(preferences.map((pref) => pref.day_of_week)),
    ];

    // Get unique times
    const uniqueTimes = {
      start: preferences[0].start_time.slice(0, 5), // Since they're all the same
      end: preferences[0].end_time.slice(0, 5),
    };

    // Get unique sport places
    const uniqueSportPlaces = [
      ...new Set(
        preferences.map(
          (pref) =>
            centersConstants.find(
              (center) => center.code === pref.sport_place_code
            ).name
        )
      ),
    ].join(", ");

    // Map days to their translated values using your constants
    const translatedDays = uniqueDays
      .map((dayCode) => {
        const day = daysConstants.find((d) => d.code === dayCode);
        return t(`team-preferences.form.day-names.${day.code.toUpperCase()}`);
      })
      .join(", ");

    setDays(translatedDays);
    setStartTime(uniqueTimes.start);
    setEndTime(uniqueTimes.end);
    setSportPlaces(uniqueSportPlaces);
    setLoading(false);

    return {
      days: translatedDays,
      times: uniqueTimes,
      sportPlaces: uniqueSportPlaces,
    };
  };

  useEffect(() => {
    retrieveData();
  }, [preferences]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <p className={`${styles.step} ${styles.blue}`}>1</p>
        <h2 className={styles.blue}>
          {t("dashboard.empty-state.preferences.success.title")}
        </h2>
        <p>
          {t("dashboard.empty-state.preferences.success.subtitle")}{" "}
          <span className={styles.blue}>
            {t("dashboard.empty-state.preferences.success.subtitle-2")}
          </span>
        </p>
      </header>
      <div className={styles.form}>
        <div className="form-group">
          <label htmlFor="days" className="required">
            {t("dashboard.empty-state.preferences.success.form.days")}
          </label>
          <input
            type="text"
            id="days"
            className="grey-input"
            value={days}
            disabled={true}
            placeholder={t(
              "onboarding.admin.informations-step.company-data.address-placeholder"
            )}
          />
        </div>
        <div className="form-group">
          <label htmlFor="centers" className="required">
            {t("dashboard.empty-state.preferences.success.form.centers")}
          </label>
          <input
            type="text"
            id="centers"
            className="grey-input"
            value={sportPlaces}
            disabled={true}
            placeholder={t(
              "onboarding.admin.informations-step.company-data.address-placeholder"
            )}
          />
        </div>
        <div className="form-group">
          <label htmlFor="times" className="required">
            {t("dashboard.empty-state.preferences.success.form.times")}
          </label>
          <input
            type="text"
            id="times"
            className="grey-input"
            value={`${startTime} - ${endTime}`}
            disabled={true}
            placeholder={t(
              "onboarding.admin.informations-step.company-data.address-placeholder"
            )}
          />
        </div>
      </div>
      {canUpdatePreferences && (
        <button className="btn btn--primary" onClick={onClick}>
          {t("dashboard.empty-state.preferences.success.linkText")}
        </button>
      )}
    </div>
  );
};

export default MatchmakingLoading;
